import React from 'react';

// mui
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Modal from '@mui/material/Modal';

// icons
import CloseIcon from '@mui/icons-material/Close';

// types
type propsType = {
    children: React.ReactNode,
    fnOnClose: () => void,
    isOpen: boolean,
}

// style
const style = {
    position: 'absolute' as 'absolute',
    width: 'calc(100vw + 2px)',
    height: 'calc(100vh + 2px)',
    top: '-1px',
    left: '-1px',
    bgcolor: 'background.paper',
    boxSizing: 'border-box',
    px: { mb: 2, tb: 4, pc: 6 },
    py: { mb: 2, tb: 3, pc: 4 },
    overflowY: "auto",
};

export default function FullScreenModal(props: propsType) {
    const {
        children,
        fnOnClose,
        isOpen,
    } = props;

    return (
        <Box sx={{position: "relative"}}>
            <Modal
                open={isOpen}
                onClose={fnOnClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            maxWidth: "980px",
                            mx: "auto",
                        }}
                    >
                        {children}
                    </Box>
                    <IconButton
                        aria-label="close"
                        onClick={fnOnClose}
                        sx={{
                            position: "absolute",
                            top: 4,
                            right: 4,
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            </Modal>
        </Box>
    );
}